<template>
  <div class="main fc ac">
    <van-cell-group style="margin-top: 110px">
      <van-cell
        v-for="(item, index) in article_list"
        :key="index"
        :title="item.title"
        @click="to(item.url)"
      />
    </van-cell-group>
  </div>
</template>

<script>
export default {
  name: "home",

  data() {
    return {
      article_list: [],
    };
  },

  methods: {
    /**
     * 获取菜单列表
     */
    getArticleMenuList() {
      let param = {
        class_id: 2,
      };
      this.post("articleMenu/getArticleMenuList", param).then((res) => {
        this.article_list = res.data;
      });
    },
    to(url) {
      location.href = url;
    },
  },
  components: {},
  mounted() {
    this.getArticleMenuList();
  },
};
</script>


<style lang="less" scoped>
.main {
  box-sizing: border-box;
  // padding: 44px;
  width: 100vw;
  min-height: 100vh;
  // height: 100vh;

  background-image: url("./../../assets/volunteer/home/bg.png");
  background-size: 100% 100%;
  background-repeat: no-repeat;
  background-color: #fffafa;
}
.active {
  background-color: #fb5358;
  color: white;
}
.black {
  color: black;
}
/deep/ .van-collapse-item__content {
  color: black;
}

/deep/ .van-collapse-item__content {
  color: black;
}
/deep/ .van-collapse-item__content {
  background-color: #fffafa;
}
.red {
  font-weight: bold;
  color: #fb5363;
}
/deep/.van-cell__title {
  font-weight: bold;
}

/deep/ .van-tabs {
  width: 100%;
}
/deep/.van-tabs__nav--card {
  margin: 0;
}
.bottom {
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 98px;
}
/deep/.van-cell-group {
  width: 100%;
}
/deep/ .van-cell__title {
  color: #fb5358;
  font-weight: bold;
}
/deep/.van-cell__title {
  font-size: 12px;
}
</style>